module.exports = __webpack_public_path__ + "img/39.cb0377ce.png";